/**
 * Einen Wert verzögert nachziehen.
 *
 * Für Suchfelder: ohne das löst jeder Buchstabe eine Abfrage aus, und bei
 * „Krummhörn" sind das elf. Die zehn davor sind nicht nur verschwendet,
 * sie kommen auch in unbestimmter Reihenfolge zurück — die Antwort auf
 * „Krumm" kann nach der auf „Krummhörn" eintreffen und sie überschreiben.
 */

import { useEffect, useState } from 'react'

export function useEntprellt<T>(wert: T, ms = 300): T {
  const [verzoegert, setzeVerzoegert] = useState(wert)

  useEffect(() => {
    const uhr = setTimeout(() => setzeVerzoegert(wert), ms)
    return () => clearTimeout(uhr)
  }, [wert, ms])

  return verzoegert
}
